import { Component, Input } from '@angular/core';
import { KeywordResearchTypes, PageSuggestion, PageSuggestionSources } from '../../../../shared/models/keywords/keywords';

@Component({
  selector: 'app-components-shared-keyword-research-page-status',
  templateUrl: './page-status.component.html',
  styleUrls: ['../keyword-research/keyword-research.component.scss']
})
export class PageStatusComponent {
  @Input() keywordResearchType: KeywordResearchTypes;
  @Input() pageSuggestion: PageSuggestion;
  @Input() pageSuggestions: PageSuggestion[];

  keywordResearchTypes_StrategyUpdate = KeywordResearchTypes.StrategyUpdate;
  websiteUrlStatuses_New = Boo.Objects.Enums.WebsiteUrlStatuses.New;
  websiteUrlStatuses_Supporting = Boo.Objects.Enums.WebsiteUrlStatuses.Supporting;
  websiteUrlStatuses_Target = Boo.Objects.Enums.WebsiteUrlStatuses.Target;

  updatePageStatus(status: Boo.Objects.Enums.WebsiteUrlStatuses): void {
    this.pageSuggestion.StatusId = status;
    this.pageSuggestion.IsModified = true;
  }

  removePage() {
    if (this.pageSuggestion.SourceId === PageSuggestionSources.User && this.pageSuggestion.PageSuggestionId === 0) {
      this.pageSuggestions.splice(this.pageSuggestions.indexOf(this.pageSuggestion), 1);
    } else {
      this.pageSuggestion.IsSelected = false;
      this.pageSuggestion.IsModified = true;
      this.pageSuggestion.PendingKeywordResearch = null;
    }
  }
}
